import { useEffect, useMemo, useState } from 'react'
import { requestSearch } from '../services'
import { Search } from '../interfaces'

type UseSearchProps = {
  query?: string
}

export const useSearch = (searchParams: UseSearchProps) => {
  const [data, setData] = useState<Search>()

  const [isLoading, setIsLoading] = useState(false)
  const [isError, setIsError] = useState(false)

  const query = useMemo(() => {
    if (!searchParams.query) return

    return (searchParams.query.trim() && searchParams.query) || undefined
  }, [searchParams.query])

  useEffect(() => {
    const requestSearchParams = { ...searchParams, query }
    if (!query) return setData(undefined)

    setIsLoading(true)
    setIsError(false)

    requestSearch(new URLSearchParams(requestSearchParams as UseSearchProps))
      .then(setData)
      .catch(() => setIsError(true))
      .finally(() => setIsLoading(false))
  }, [query])

  return { data, isLoading, isError }
}
